module.exports = __webpack_public_path__ + "img/Platine_0003_4.761e0a72.png";